// DO NOT EDIT — generated by `just analytics-fold-map` from
// analytics/internal/service/stats/reservations/addresses/identity.go
// (addresses.LatinToGreekLookAlikes). Change the Go map and re-run the recipe;
// `just analytics-types` runs it for you.
//
// address-normalization/FR-010: the apartment form's address search folds with
// the same character table as the server's identity key, so the two can never
// disagree about whether two spellings are the same building.

/** Upper-case Latin letter → the Greek letter it is indistinguishable from. */
export const latinToGreekLookAlikes: ReadonlyMap<string, string> = new Map([
    ["\u0041", "\u0391"], // LATIN CAPITAL LETTER A → GREEK CAPITAL LETTER ALPHA
    ["\u0042", "\u0392"], // LATIN CAPITAL LETTER B → GREEK CAPITAL LETTER BETA
    ["\u0045", "\u0395"], // LATIN CAPITAL LETTER E → GREEK CAPITAL LETTER EPSILON
    ["\u0048", "\u0397"], // LATIN CAPITAL LETTER H → GREEK CAPITAL LETTER ETA
    ["\u0049", "\u0399"], // LATIN CAPITAL LETTER I → GREEK CAPITAL LETTER IOTA
    ["\u004B", "\u039A"], // LATIN CAPITAL LETTER K → GREEK CAPITAL LETTER KAPPA
    ["\u004D", "\u039C"], // LATIN CAPITAL LETTER M → GREEK CAPITAL LETTER MU
    ["\u004E", "\u039D"], // LATIN CAPITAL LETTER N → GREEK CAPITAL LETTER NU
    ["\u004F", "\u039F"], // LATIN CAPITAL LETTER O → GREEK CAPITAL LETTER OMICRON
    ["\u0050", "\u03A1"], // LATIN CAPITAL LETTER P → GREEK CAPITAL LETTER RHO
    ["\u0054", "\u03A4"], // LATIN CAPITAL LETTER T → GREEK CAPITAL LETTER TAU
    ["\u0058", "\u03A7"], // LATIN CAPITAL LETTER X → GREEK CAPITAL LETTER CHI
    ["\u0059", "\u03A5"], // LATIN CAPITAL LETTER Y → GREEK CAPITAL LETTER UPSILON
    ["\u005A", "\u0396"], // LATIN CAPITAL LETTER Z → GREEK CAPITAL LETTER ZETA
]);
